import React from "react";
import { Link } from "react-router-dom";

import "./styles.scss";

import Logo from "components/atoms/logo/index.jsx";
import CompanyInfo from "components/atoms/companyInfo/index.jsx";
import Nav from "components/molecules/nav/index.jsx";

export default class Header extends React.Component {
  render() {
    return (
      <div className="header">
        <div className="headerContainer">
          <div className="logo">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="headerNav">
            <Nav />
          </div>
          <div className="headerCompanyInfo">
            <CompanyInfo />
          </div>
        </div>
      </div>
    );
  }
}
